import React, { useState, useEffect } from 'react';
import { Copy, Loader2, Rocket, Check, AlertCircle, Sliders, AlignLeft, Zap, Plus, Trash2, Table, ShoppingBag, Tag, ListOrdered, Sun, Moon, Download } from 'lucide-react';
import XLSXStyle from 'xlsx-js-style';

export default function App() {
  // XÁC THỰC MẬT KHẨU
  const savedPassword = localStorage.getItem('tool_password') || '';
  const [toolPassword, setToolPassword] = useState(savedPassword);
  const [isAuthenticated, setIsAuthenticated] = useState(savedPassword === '123');

  // CẤU HÌNH API
  const [provider, setProvider] = useState(localStorage.getItem('provider') || 'deepseek');
  const [selectedModel, setSelectedModel] = useState(localStorage.getItem('selected_model') || 'deepseek-v4-flash');
  const [apiKeys, setApiKeys] = useState({
    google: localStorage.getItem('api_key_google') || '',
    openai: localStorage.getItem('api_key_openai') || '',
    deepseek: localStorage.getItem('api_key_deepseek') || ''
  });
  const [isDark, setIsDark] = useState(() => localStorage.getItem('theme') === 'dark');
  const [outputLanguage, setOutputLanguage] = useState(localStorage.getItem('output_language') || 'en');
  const [productType, setProductType] = useState(localStorage.getItem('product_type') || 'physical');

  const productTypeOptions = [
    { value: 'physical', icon: '📦', label: 'Sản Phẩm Vật Lý',  labelEn: 'Physical Product' },
    { value: 'digital',  icon: '💻', label: 'Sản Phẩm Số',      labelEn: 'Digital Product' },
    { value: 'service',  icon: '🔧', label: 'Dịch Vụ',           labelEn: 'Service' },
  ];

  const productTypePromptContext = {
    digital:  'PRODUCT TYPE: This is a DIGITAL product (software, SaaS, app, digital download, online course, or digital subscription). Do NOT mention physical shipping or delivery times. Emphasize instant access, digital delivery, online features, compatibility, and global availability.',
    physical: 'PRODUCT TYPE: This is a PHYSICAL product (tangible goods requiring shipping). Mention product quality, craftsmanship, materials, and shipping/delivery where relevant.',
    service:  'PRODUCT TYPE: This is a SERVICE business (consulting, subscription platform, online service, or agency). Focus on service quality, reliability, customer support, pricing plans, and the value it delivers to clients.',
  };

  const languageOptions = [
    { value: 'en',    flag: '🇺🇸', text: 'English (US)' },
    { value: 'vi',    flag: '🇻🇳', text: 'Tiếng Việt' },
    { value: 'es',    flag: '🇪🇸', text: 'Spanish' },
    { value: 'fr',    flag: '🇫🇷', text: 'French' },
    { value: 'de',    flag: '🇩🇪', text: 'German' },
    { value: 'pt',    flag: '🇧🇷', text: 'Portuguese (BR)' },
    { value: 'ja',    flag: '🇯🇵', text: 'Japanese' },
    { value: 'ko',    flag: '🇰🇷', text: 'Korean' },
    { value: 'zh',    flag: '🇨🇳', text: 'Chinese (Simplified)' },
    { value: 'ar',    flag: '🇸🇦', text: 'Arabic' },
    { value: 'th',    flag: '🇹🇭', text: 'Thai' },
    { value: 'id',    flag: '🇮🇩', text: 'Indonesian' },
  ];

  const languageNames = {
    en: 'English (US)',
    vi: 'Vietnamese',
    es: 'Spanish',
    fr: 'French',
    de: 'German',
    pt: 'Portuguese (Brazilian)',
    ja: 'Japanese',
    ko: 'Korean',
    zh: 'Chinese (Simplified)',
    ar: 'Arabic',
    th: 'Thai',
    id: 'Indonesian',
  };

  // Bảng dịch cho các chuỗi hardcode trong bảng STORE & COUPON
  const translations = {
    //                 off                   sitewide                                   at       waitingSale                freeShip (physical)                                    freeAccess (digital)                  freeTrial (service)                   trending
    en: { off: 'Off',              sitewide: 'Site-wide on All Orders',              at: 'At',    waitingSale: 'Waiting Sale',           freeShip: 'Fast & Free Shipping for All Orders',         freeAccess: 'Instant Digital Access',         freeTrial: 'Free Trial Available',          trending: 'Trending'     },
    vi: { off: 'Giảm',             sitewide: 'Toàn Trang Cho Tất Cả Đơn Hàng',      at: 'Tại',   waitingSale: 'Chờ Khuyến Mãi',         freeShip: 'Miễn Phí Vận Chuyển Tất Cả Đơn Hàng',        freeAccess: 'Truy Cập Ngay Lập Tức',          freeTrial: 'Dùng Thử Miễn Phí',             trending: 'Nổi Bật'      },
    es: { off: 'de Descuento',     sitewide: 'en Todo el Sitio',                     at: 'En',    waitingSale: 'Esperando Oferta',        freeShip: 'Envío Rápido y Gratuito en Todos los Pedidos', freeAccess: 'Acceso Digital Instantáneo',      freeTrial: 'Prueba Gratuita Disponible',     trending: 'Tendencia'    },
    fr: { off: 'de Réduction',     sitewide: 'sur Tout le Site',                     at: 'Chez',  waitingSale: 'En Attente de Promotion', freeShip: 'Livraison Rapide et Gratuite',                 freeAccess: 'Accès Numérique Instantané',      freeTrial: 'Essai Gratuit Disponible',       trending: 'Tendance'     },
    de: { off: 'Rabatt',           sitewide: 'Sitewide auf Alle Bestellungen',        at: 'Bei',   waitingSale: 'Warten auf Angebot',      freeShip: 'Schneller & Kostenloser Versand',              freeAccess: 'Sofortiger Digitaler Zugang',     freeTrial: 'Kostenlose Testversion',         trending: 'Trend'        },
    pt: { off: 'de Desconto',      sitewide: 'em Todo o Site',                       at: 'Em',    waitingSale: 'Aguardando Promoção',     freeShip: 'Frete Rápido e Gratuito em Todos os Pedidos',  freeAccess: 'Acesso Digital Instantâneo',      freeTrial: 'Teste Gratuito Disponível',      trending: 'Em Alta'      },
    ja: { off: 'オフ',             sitewide: 'サイト全体の全注文に適用',              at: '—',     waitingSale: 'セール待ち',              freeShip: '全注文への迅速・無料配送',                     freeAccess: 'デジタル即時アクセス',           freeTrial: '無料トライアル利用可能',         trending: 'トレンド'     },
    ko: { off: '할인',             sitewide: '사이트 전체 모든 주문 적용',            at: '—',     waitingSale: '세일 대기',               freeShip: '모든 주문 빠른 무료 배송',                     freeAccess: '즉시 디지털 접근',               freeTrial: '무료 체험 이용 가능',            trending: '트렌딩'       },
    zh: { off: '折扣',             sitewide: '全站所有订单适用',                      at: '—',     waitingSale: '等待促销',                freeShip: '全部订单快速免费送货',                         freeAccess: '即时数字访问',                   freeTrial: '免费试用可用',                   trending: '热门'         },
    ar: { off: 'خصم',              sitewide: 'على جميع الطلبات',                     at: 'في',    waitingSale: 'في انتظار العرض',         freeShip: 'شحن سريع ومجاني لجميع الطلبات',               freeAccess: 'وصول رقمي فوري',                 freeTrial: 'تجربة مجانية متاحة',             trending: 'رائج'         },
    th: { off: 'ส่วนลด',          sitewide: 'ทั่วทั้งเว็บสำหรับทุกคำสั่งซื้อ',    at: 'ที่',   waitingSale: 'รอโปรโมชั่น',            freeShip: 'จัดส่งฟรีและรวดเร็วสำหรับทุกคำสั่งซื้อ',    freeAccess: 'เข้าถึงดิจิทัลทันที',          freeTrial: 'ทดลองใช้ฟรี',                   trending: 'กำลังมาแรง'  },
    id: { off: 'Diskon',           sitewide: 'di Seluruh Situs untuk Semua Pesanan', at: 'Di',    waitingSale: 'Menunggu Promo',          freeShip: 'Pengiriman Cepat & Gratis untuk Semua Pesanan', freeAccess: 'Akses Digital Instan',            freeTrial: 'Uji Coba Gratis Tersedia',       trending: 'Tren'         },
  };
  const t = translations[outputLanguage] || translations.en;

  // Text cho hàng "miễn phí" trong bảng coupon theo loại sản phẩm
  const freeRowConfig = {
    digital:  { saleOff: 'FREE ACCESS', title: (name) => `${t.freeAccess} ${t.at} ${name}` },
    physical: { saleOff: 'FREE SHIPPING', title: (name) => `${t.freeShip} ${t.at} ${name}` },
    service:  { saleOff: 'FREE TRIAL',  title: (name) => `${t.freeTrial} ${t.at} ${name}` },
  };

  const modelOptions = {
    google: [
      { value: 'gemini-2.5-flash-preview-09-2025', text: 'Gemini 2.5 Flash (Mới nhất)' },
      { value: 'gemini-2.0-flash', text: 'Gemini 2.0 Flash' }
    ],
    openai: [
      { value: 'gpt-4o', text: 'GPT-4o (Khuyên dùng)' },
      { value: 'gpt-4o-mini', text: 'GPT-4o Mini' }
    ],
    deepseek: [
      { value: 'deepseek-v4-flash', text: 'DeepSeek-V4-Flash (Mới nhất)' },
      { value: 'deepseek-v4-pro', text: 'DeepSeek-V4-Pro (Giảm 75%)' },
      { value: 'deepseek-chat', text: 'DeepSeek-Chat (Legacy)' },
      { value: 'deepseek-reasoner', text: 'DeepSeek-Reasoner (Legacy)' }
    ]
  };

  const providerInfo = {
    google: { name: 'Google (Gemini)', label: 'Gemini API Key', link: 'https://aistudio.google.com/app/apikey' },
    openai: { name: 'OpenAI (GPT)', label: 'OpenAI API Key', link: 'https://platform.openai.com/api-keys' },
    deepseek: { name: 'DeepSeek', label: 'DeepSeek API Key', link: 'https://platform.deepseek.com/api_keys' }
  };


  // STATE DỮ LIỆU
  // Queue chứa danh sách các dự án chuẩn bị tạo
  const initialSingleProject = {
    id: 'single-1', category: '', projectName: '', websiteUrl: '', imageUrl: '', affiliateLink: '', couponCode: '', discountPercent: ''
  };
  const [projectsQueue, setProjectsQueue] = useState(() => {
    try { const s = localStorage.getItem('projects_queue'); return s ? JSON.parse(s) : [initialSingleProject]; } catch { return [initialSingleProject]; }
  });
  const [quickPasteValue, setQuickPasteValue] = useState(() => localStorage.getItem('quick_paste') || '');

  // Results chứa dữ liệu sau khi AI đã xử lý xong
  const [results, setResults] = useState([]);
  // Custom Coupons do user tự thêm cho từng dự án { id, projectId, code, saleOff }
  const [addedCoupons, setAddedCoupons] = useState(() => {
    try { const s = localStorage.getItem('added_coupons'); return s ? JSON.parse(s) : []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem('projects_queue', JSON.stringify(projectsQueue)); }, [projectsQueue]);
  useEffect(() => { localStorage.setItem('quick_paste', quickPasteValue); }, [quickPasteValue]);
  useEffect(() => { localStorage.setItem('added_coupons', JSON.stringify(addedCoupons)); }, [addedCoupons]);

  // TRẠNG THÁI UI
  const [isLoading, setIsLoading] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(''); 
  const [error, setError] = useState('');
  
  const [isCopiedDesc, setIsCopiedDesc] = useState(false);
  const [isCopiedTable, setIsCopiedTable] = useState(false);
  const [isCopiedStore, setIsCopiedStore] = useState(false); 
  const [isCopiedCoupon, setIsCopiedCoupon] = useState(false); 

  const baseQuestions = [
    "Where can I find the latest {store} coupons?",
    "Are there any active {store} promo codes or deals today?",
    "What is the best {store} coupon code right now?",
    "Do {store} coupons expire?",
    "Is there a minimum order value to use {store} promo codes?",
    "What should I do if my {store} coupon code isn't working?",
    "Where do I enter a {store} promo code during checkout?",
    "Can I stack multiple {store} coupons in one order?",
    "Does {store} offer student discounts?",
    "Does {store} offer discounts for first-time buyers?",
    "Are there any site-wide coupons for {store}?",
    "Does {store} offer flash sales or daily deals?",
    "Do {store} promo codes work on sale items?",
    "Does {store} participate in Black Friday or Cyber Monday?",
    "Are there holiday or seasonal sales on {store}?",
    "Does {store} offer exclusive discounts on its app?",
    "Are there discounts for auto-order subscriptions on {store}?",
    "What are the latest {store} promo codes on couponhub.me this year?",
    "Is couponhub.me offering verified {store} discount codes?",
    "How often does couponhub.me update {store} coupons?",
    "Are {store} coupons from couponhub.me stackable?",
    "Does couponhub.me have exclusive {store} first-time buyer discounts?"
  ];

  // HÀM TIỆN ÍCH
  const formatProjectName = (name) => {
    if (!name) return '';
    return name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

  const getSaleText = (val) => {
    if (!val) return '';
    const cleanVal = val.trim();
    if (outputLanguage === 'en') {
      if (cleanVal.toLowerCase().includes('off')) return `${cleanVal} Site-wide on All Orders`;
      return `${cleanVal} Off Site-wide on All Orders`;
    }
    // Các ngôn ngữ khác: [giá trị] [từ "giảm"] [toàn trang...]
    return `${cleanVal} ${t.off} ${t.sitewide}`;
  };

  const handleProviderChange = (e) => {
    const newProvider = e.target.value;
    const newModel = modelOptions[newProvider][0].value;
    setProvider(newProvider);
    setSelectedModel(newModel);
    localStorage.setItem('provider', newProvider);
    localStorage.setItem('selected_model', newModel);
  };

  const handleApiKeyChange = (e) => {
    const val = e.target.value;
    setApiKeys(prev => ({ ...prev, [provider]: val }));
    localStorage.setItem(`api_key_${provider}`, val);
  };

  // Parser TSV chuẩn — xử lý ô có xuống dòng bên trong (Excel wrap bằng dấu ")
  const parseTSV = (text) => {
    const rows = [];
    let currentRow = [];
    let currentField = '';
    let inQuotes = false;

    for (let i = 0; i < text.length; i++) {
      const ch = text[i];
      if (ch === '"') {
        if (inQuotes && text[i + 1] === '"') { currentField += '"'; i++; }
        else inQuotes = !inQuotes;
      } else if (ch === '\t' && !inQuotes) {
        currentRow.push(currentField); currentField = '';
      } else if ((ch === '\n' || ch === '\r') && !inQuotes) {
        if (ch === '\r' && text[i + 1] === '\n') i++; // skip \r\n
        currentRow.push(currentField); currentField = '';
        if (currentRow.some(f => f.trim())) rows.push(currentRow);
        currentRow = [];
      } else {
        currentField += ch;
      }
    }
    // Hàng cuối không có \n
    currentRow.push(currentField);
    if (currentRow.some(f => f.trim())) rows.push(currentRow);
    return rows;
  };

  // HÀM XỬ LÝ NHẬP NHANH (QUICK PASTE)
  const handleQuickPaste = (e) => {
    const text = e.target.value;
    setQuickPasteValue(text);

    if (!text.trim()) {
      setProjectsQueue([initialSingleProject]);
      return;
    }

    const rows = parseTSV(text);
    if (rows.length === 0) return;

    const newParsedProjects = rows.map((cols, idx) => ({
      id: `queued-${Date.now()}-${idx}`,
      category:        cols[0]?.trim()  || '',
      projectName:     cols[1]?.trim()  || '',
      websiteUrl:      cols[2]?.trim()  || '',
      imageUrl:        cols[4]?.trim()  || '',
      affiliateLink:   cols[9]?.trim()  || '',
      couponCode:      cols[11]?.trim() || '',
      discountPercent: cols[12]?.trim() || ''
    }));

    if (newParsedProjects.length > 0) {
      setProjectsQueue(prevQueue => {
        if (prevQueue.length === 1 && !prevQueue[0].projectName.trim()) return newParsedProjects;
        return [...prevQueue, ...newParsedProjects];
      });
      setTimeout(() => setQuickPasteValue(''), 800);
    }
  };

  // HÀM CẬP NHẬT SINGLE INPUT KHI ĐANG Ở CHẾ ĐỘ 1 PROJECT
  const updateSingleQueueField = (field, value) => {
    if (projectsQueue.length !== 1) return;
    const updated = [...projectsQueue];
    updated[0][field] = value;
    setProjectsQueue(updated);
  };

  // QUẢN LÝ COUPON TÙY CHỈNH THEO TỪNG PROJECT
  const handleAddCouponRow = (projectId) => {
    setAddedCoupons([...addedCoupons, { id: Date.now(), projectId, code: '', saleOff: '' }]);
  };

  const handleRemoveCouponRow = (id) => {
    setAddedCoupons(addedCoupons.filter(c => c.id !== id));
  };

  const updateAddedCoupon = (id, field, value) => {
    setAddedCoupons(addedCoupons.map(c => c.id === id ? { ...c, [field]: value } : c));
  };

  const updateResultData = (id, field, value) => {
    setResults(results.map(r => r.id === id ? { ...r, [field]: value } : r));
  };

  const clearQueue = () => {
    setProjectsQueue([initialSingleProject]);
    setResults([]);
    setAddedCoupons([]);
  };

  // XỬ LÝ API (SCRAPE + AI) CHO 1 DỰ ÁN
  const processSingleProject = async (project, apiKey) => {
    let siteContext = "";
    let finalUrl = project.websiteUrl;
    const formattedName = formatProjectName(project.projectName);
    
    if (finalUrl) {
      if (!finalUrl.startsWith('http')) finalUrl = 'https://' + finalUrl;
      try {
        const proxyUrl = `https://api.allorigins.win/get?url=${encodeURIComponent(finalUrl)}`;
        const proxyRes = await fetch(proxyUrl);
        if (proxyRes.ok) {
          const proxyData = await proxyRes.json();
          if (proxyData && proxyData.contents) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(proxyData.contents, "text/html");
            const title = doc.querySelector('title')?.textContent || '';
            const metaDesc = doc.querySelector('meta[name="description"]')?.content || doc.querySelector('meta[property="og:description"]')?.content || '';
            doc.querySelectorAll('script, style, noscript, iframe').forEach(el => el.remove());
            const bodyText = doc.body?.textContent?.replace(/\s+/g, ' ')?.trim().substring(0, 1500) || '';
            if (title || metaDesc || bodyText) {
              siteContext = `[Website Real-Time Data Extracted]:\n- Title: ${title}\n- Meta Description: ${metaDesc}\n- Page Content Snippet: ${bodyText}\n`;
            }
          }
        }
      } catch (err) {
        console.warn("Không thể quét website:", err);
      }
    }

    const faqPromptQuestions = baseQuestions.map(q => q.replace(/{store}/g, formattedName)).join('\n');
    const isEnglish = outputLanguage === 'en';
    const targetLang = languageNames[outputLanguage] || 'English (US)';
    const langInstruction = isEnglish
      ? 'Write in English (US).'
      : `IMPORTANT — OUTPUT LANGUAGE: You MUST write ALL content entirely in ${targetLang}. This includes the product description paragraph, every FAQ question, and every FAQ answer. Do NOT use English in any part of your output. If a proper noun or brand name must stay in its original form, that is the only exception.`;

    const ptContext = productTypePromptContext[productType] || productTypePromptContext.digital;

    const prompt = `You are an expert SEO copywriter. Write a brief, engaging product/company introduction and an FAQ section for the brand below.
    Brand Name: ${formattedName}
    Website URL: ${finalUrl || 'Not provided'}
    ${siteContext
      ? `\nCRITICAL CONTEXT (Scraped directly from their live website — HIGHEST PRIORITY):\n${siteContext}\n=> You MUST use this scraped data as the primary source of truth. Identify exactly what niche, products, or services this brand sells based on the real content above.\n`
      : `\nNo website data could be scraped. Infer the brand's niche and products from the Brand Name "${formattedName}" and the Website URL "${finalUrl || 'not provided'}". Make your best educated guess about their product/service category.\n`
    }

    ${ptContext}

    ${langInstruction}

    CRITICAL FORMATTING INSTRUCTIONS:
    Your output MUST consist of two main sections:

    === SECTION 1: PRODUCT DESCRIPTION ===
    1. Line 1: MUST be exactly "${formattedName} Coupons and Promo Codes" (without quotes).
    2. Line 2 (and onwards): The actual company/product description. This description MUST start exactly with the brand name "${formattedName} ".
    - Base your description heavily on the CRITICAL CONTEXT provided above. Identify their exact niche.
    - Accurately describe their core product/service.
    - You MUST specifically mention at least one of their hottest, most popular, or flagship products/categories.
    - You MUST explicitly identify their primary target audience based on the niche found in the context.
    - Mention their primary target country or market if it's obvious.
    - ABSOLUTELY DO NOT mention coupons, promo codes, discounts, deals, or savings in this paragraph. Focus ONLY on their actual business.
    - Write exactly 3 to 4 sentences.
    - Ensure the tone is professional and persuasive.

    === SECTION 2: FAQ TABLE ===
    Leave a blank line after the description, then output an FAQ section presented STRICTLY as a Markdown Table with exactly 3 columns:
    | Question | Answer | Store Name |
    |---|---|---|

    You MUST include exactly the following 22 questions in Column 1 (translate them to ${targetLang} if the output language is not English):
    ${faqPromptQuestions}

    For Column 2 (Answer), write a helpful, SEO-optimized, short answer (1-2 sentences) for each question in ${targetLang}. Be realistic and persuasive.
    For Column 3 (Store Name), output exactly "${formattedName}" for every single row.`;

    const systemText = isEnglish
      ? "You are an expert SEO copywriter. You follow instructions strictly and output Markdown tables perfectly."
      : `You are an expert SEO copywriter fluent in ${targetLang}. You follow instructions strictly, write entirely in ${targetLang}, and output Markdown tables perfectly.`;
    let text = "";

    // Fetch API logic
    const delays = [1000, 2000, 4000]; // 3 retries
    for (let i = 0; i < delays.length; i++) {
      try {
        if (provider === 'google') {
          const url = `https://generativelanguage.googleapis.com/v1beta/models/${selectedModel}:generateContent?key=${apiKey}`;
          const res = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              contents: [{ parts: [{ text: prompt }] }],
              systemInstruction: { parts: [{ text: systemText }] }
            })
          });
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          const data = await res.json();
          text = data.candidates?.[0]?.content?.parts?.[0]?.text;
        } 
        else {
          const endpoint = provider === 'openai' ? 'https://api.openai.com/v1/chat/completions' : 'https://api.deepseek.com/chat/completions';
          const res = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${apiKey}`
            },
            body: JSON.stringify({
              model: selectedModel,
              messages: [{ role: "system", content: systemText }, { role: "user", content: prompt }],
              temperature: 0.7
            })
          });
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          const data = await res.json();
          text = data.choices?.[0]?.message?.content;
        }
        if (text) break; // success
      } catch (err) {
        if (i === delays.length - 1) throw err;
        await new Promise(resolve => setTimeout(resolve, delays[i]));
      }
    }

    if (!text) return null;

    // Parse Text
    let isTableMode = false;
    const parsedFaq = [];
    const descLines = [];
    
    text.split('\n').forEach(line => {
      const tLine = line.trim();
      // Nhận diện dòng separator |---|---|---| theo mọi ngôn ngữ
      const isSeparator = tLine.startsWith('|') && /^[\|\-\s:]+$/.test(tLine);
      if (isSeparator) {
        if (!isTableMode) {
          isTableMode = true;
          if (descLines.length > 0) descLines.pop(); // xóa dòng header vừa thêm vào desc
        }
        return;
      }
      if (isTableMode && tLine.startsWith('|')) {
        const cols = tLine.split('|').map(c => c.trim()).filter((c, idx, arr) => idx > 0 && idx < arr.length - 1);
        if (cols.length >= 3) parsedFaq.push({ question: cols[0], answer: cols[1], store: cols[2] });
      } else {
        if (!isTableMode && !/SECTION\s*[12]/i.test(tLine) && !/^={3,}/.test(tLine)) descLines.push(line);
      }
    });

    const cleanDescLines = descLines
      .filter(l => l.trim() !== '')
      .filter(l => !l.toLowerCase().includes('coupons and promo codes'))
      .filter(l => !l.trim().startsWith('<!--'))
      .filter(l => !/^#{1,6}\s/.test(l.trim()))                          // ## Markdown headings
      .filter(l => !/^[-=*_]{3,}$/.test(l.trim()))                       // --- horizontal rules
      .filter(l => !/^\*{0,2}(Note|Disclaimer|Warning|Important)\*{0,2}[:：]/i.test(l.trim())) // **Note:** annotations
      .filter(l => !/^(Here is|Here's|Certainly|Sure,|Of course|Below is|As requested)/i.test(l.trim())); // preamble
    return {
      descTitle: formattedName,
      descContent: cleanDescLines.join('\n').trim(),
      faq: parsedFaq
    };
  };

  // GENERATE HÀNG LOẠT
  const handleGenerate = async (e) => {
    e.preventDefault();
    
    const validQueue = projectsQueue.filter(p => p.projectName.trim());
    if (validQueue.length === 0) {
      setError('Vui lòng nhập ít nhất 1 tên dự án.');
      return;
    }

    const currentApiKey = apiKeys[provider].trim();
    if (!currentApiKey) {
      setError(`Vui lòng nhập API Key cho ${providerInfo[provider].name}.`);
      return;
    }

    setIsLoading(true);
    setError('');
    setResults([]);
    setAddedCoupons([]);

    let tempResults = [];
    const BATCH_SIZE = 3;

    for (let i = 0; i < validQueue.length; i += BATCH_SIZE) {
      const batch = validQueue.slice(i, i + BATCH_SIZE);
      const batchEnd = Math.min(i + BATCH_SIZE, validQueue.length);
      setLoadingStatus(`Đang xử lý (${i + 1}–${batchEnd}/${validQueue.length})...`);

      const batchResults = await Promise.allSettled(
        batch.map(p => processSingleProject(p, currentApiKey))
      );

      batchResults.forEach((result, idx) => {
        const project = batch[idx];
        if (result.status === 'fulfilled' && result.value) {
          tempResults.push({ ...project, projectName: formatProjectName(project.projectName), ...result.value });
        } else {
          tempResults.push({ ...project, descTitle: project.projectName, descContent: 'Lỗi API hoặc mạng.', faq: [] });
        }
      });

      setResults([...tempResults]);

      if (i + BATCH_SIZE < validQueue.length) {
        await new Promise(res => setTimeout(res, 500));
      }
    }

    setIsLoading(false);
    setLoadingStatus('');
  };

  // CHUẨN BỊ DỮ LIỆU BẢNG COUPON HÀNG LOẠT
  // Tạo ra danh sách flat các hàng cho bảng Coupon
  const getCouponTableRows = () => {
    let rows = [];

    // Nếu có kết quả, render theo kết quả. Nếu không, render hàng ảo tạm thời cho 1 dự án nhập dở.
    const sourceData = results.length > 0 ? results : (projectsQueue.length === 1 && projectsQueue[0].projectName ? [{...projectsQueue[0], projectName: formatProjectName(projectsQueue[0].projectName)}] : []);

    sourceData.forEach(res => {
      let localStt = 1; // Thêm dòng này: Reset STT về 1 cho mỗi dự án mới

      const projCoupons = addedCoupons.filter(c => c.projectId === res.id);
      const name = res.projectName || '[Tên Shop]';
      const cCat = res.category || '';
      const cLink = res.affiliateLink || '';

      // Hàng 1
      rows.push({
        id: `global-1-${res.id}`, projectId: res.id, stt: localStt++, rowType: 'global-code',
        code: res.couponCode || '', saleOff: res.discountPercent || '',
        titleDesc: res.discountPercent ? `${getSaleText(res.discountPercent)} ${t.at} ${name}` : `${t.waitingSale} ${t.at} ${name}`,
        storeName: name, category: cCat, link: cLink
      });

      // Các hàng Custom
      projCoupons.forEach(c => {
        rows.push({
          id: c.id, projectId: res.id, stt: localStt++, rowType: 'custom',
          code: c.code, saleOff: c.saleOff,
          titleDesc: c.saleOff ? `${getSaleText(c.saleOff)} ${t.at} ${name}` : `${t.waitingSale} ${t.at} ${name}`,
          storeName: name, category: cCat, link: cLink
        });
      });

      // Hàng 2 (Không code)
      rows.push({
        id: `global-2-${res.id}`, projectId: res.id, stt: localStt++, rowType: 'global-nocode',
        code: '', saleOff: res.discountPercent || '',
        titleDesc: res.discountPercent ? `${getSaleText(res.discountPercent)} ${t.at} ${name}` : `${t.waitingSale} ${t.at} ${name}`,
        storeName: name, category: cCat, link: cLink
      });

      // Hàng 3 (Free — nội dung thay đổi theo loại sản phẩm)
      const freeRow = freeRowConfig[productType] || freeRowConfig.physical;
      rows.push({
        id: `global-3-${res.id}`, projectId: res.id, stt: localStt++, rowType: 'global-freeship',
        code: '', saleOff: freeRow.saleOff,
        titleDesc: freeRow.title(name),
        storeName: name, category: cCat, link: cLink
      });
    });

    return rows;
  };

  const allCouponRows = getCouponTableRows();

  // CÁC HÀM COPY (HOẠT ĐỘNG TRÊN TẤT CẢ PROJECTS TRONG RESULTS)
  const executeCopy = (textToCopy, setStatusFunc) => {
    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    textArea.style.top = "0"; textArea.style.left = "0"; textArea.style.position = "fixed";
    document.body.appendChild(textArea); textArea.focus(); textArea.select();
    try {
      document.execCommand('copy');
      setStatusFunc(true); setTimeout(() => setStatusFunc(false), 2000);
    } catch (err) { setError('Lỗi khi sao chép.'); }
    document.body.removeChild(textArea);
  };

  const copyDescToExcel = () => {
    if (results.length === 0) return;
    let tsv = "";
    results.forEach(res => {
      const cleanTitle = res.descTitle.replace(/\t|\n/g, ' ');
      const cleanContent = `"${(res.descContent || '').replace(/"/g, '""')}"`;
      tsv += `${cleanTitle}\t${cleanContent}\n`;
    });
    executeCopy(tsv, setIsCopiedDesc);
  };

  const copyTableToExcel = () => {
    if (results.length === 0) return;
    let tsv = "";
    results.forEach(res => {
      if(res.faq) {
        res.faq.forEach(row => {
          tsv += `${row.question.replace(/\t|\n/g, ' ')}\t${row.answer.replace(/\t|\n/g, ' ')}\t${row.store.replace(/\t|\n/g, ' ')}\n`;
        });
      }
    });
    executeCopy(tsv, setIsCopiedTable);
  };

  const copyStoreToExcel = () => {
    if (results.length === 0) return;
    let tsv = "";
    results.forEach(res => {
      const cleanImg = (res.imageUrl || '').replace(/\t|\n/g, ' ').trim();
      const cleanTitle = res.projectName.replace(/\t|\n/g, ' ').trim();
      const cleanLink = (res.affiliateLink || '').replace(/\t|\n/g, ' ').trim();
      
      // Bỏ tự động xóa \n để giữ lại việc xuống dòng giữa phần Coupons và phần Mô tả
      const cleanDesc = `"${(res.descContent || '').replace(/"/g, '""').replace(/\t/g, ' ')}"`;
      
      const storeSaleText = getSaleText(res.discountPercent).replace(/\t|\n/g, ' ');
      
      tsv += `${cleanImg}\t${cleanTitle}\t${cleanLink}\t${cleanDesc}\t${storeSaleText}\t${storeSaleText}\tTrending\n`;
    });
    executeCopy(tsv, setIsCopiedStore);
  };

  const copyCouponToExcel = () => {
    if (allCouponRows.length === 0) return;
    let tsv = "";
    allCouponRows.forEach(row => {
      const cCode = row.code.replace(/\t|\n/g, ' ').trim();
      const cSale = row.saleOff.replace(/\t|\n/g, ' ').trim();
      const cTitleDesc = row.titleDesc.replace(/\t|\n/g, ' ').trim();
      tsv += `${row.stt}\t\t${cCode}\t${cSale}\t${cTitleDesc}\t${cTitleDesc}\t${row.storeName}\t${row.category}\t${row.link}\n`;
    });
    executeCopy(tsv, setIsCopiedCoupon);
  };

  const downloadFaqXlsx = () => {
    if (results.length === 0) return;

    const headerStyle = {
      font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11 },
      fill: { fgColor: { rgb: '2E7D32' } },
      alignment: { horizontal: 'center', vertical: 'center', wrapText: false },
      border: {
        top: { style: 'thin', color: { rgb: 'CCCCCC' } },
        bottom: { style: 'thin', color: { rgb: 'CCCCCC' } },
        left: { style: 'thin', color: { rgb: 'CCCCCC' } },
        right: { style: 'thin', color: { rgb: 'CCCCCC' } },
      }
    };
    const cellStyle = {
      alignment: { vertical: 'top', wrapText: true },
      border: {
        top: { style: 'thin', color: { rgb: 'E0E0E0' } },
        bottom: { style: 'thin', color: { rgb: 'E0E0E0' } },
        left: { style: 'thin', color: { rgb: 'E0E0E0' } },
        right: { style: 'thin', color: { rgb: 'E0E0E0' } },
      }
    };

    const makeSheet = (headers, rows, colWidths) => {
      const data = [
        headers.map(h => ({ v: h, t: 's', s: headerStyle })),
        ...rows.map(row => row.map(val => ({ v: val || '', t: 's', s: cellStyle })))
      ];
      const ws = XLSXStyle.utils.aoa_to_sheet(data);
      ws['!cols'] = colWidths.map(w => ({ wch: w }));
      ws['!rows'] = [{ hpt: 22 }];
      return ws;
    };

    // Sheet 1: category
    const catRows = results.map(res => [res.descTitle, res.descContent || '']);
    const wsCategory = makeSheet(['title', 'description'], catRows, [30, 120]);

    // Sheet 2: faq
    const faqData = [];
    results.forEach(res => {
      (res.faq || []).forEach(row => faqData.push([row.question, row.answer, row.store]));
    });
    const wsFaq = makeSheet(['title', 'description', 'category'], faqData, [55, 80, 25]);

    const wb = XLSXStyle.utils.book_new();
    XLSXStyle.utils.book_append_sheet(wb, wsCategory, 'category');
    XLSXStyle.utils.book_append_sheet(wb, wsFaq, 'faq');

    const firstName = results[0]?.descTitle?.replace(/[^a-zA-Z0-9]/g, '_') || 'export';
    XLSXStyle.writeFile(wb, `faq_import_${firstName}.xlsx`);
  };

  const downloadCouponXlsx = () => {
    if (results.length === 0) return;

    const headerStyle = {
      font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11 },
      fill: { fgColor: { rgb: '2E7D32' } },
      alignment: { horizontal: 'center', vertical: 'center', wrapText: false },
      border: {
        top: { style: 'thin', color: { rgb: 'CCCCCC' } },
        bottom: { style: 'thin', color: { rgb: 'CCCCCC' } },
        left: { style: 'thin', color: { rgb: 'CCCCCC' } },
        right: { style: 'thin', color: { rgb: 'CCCCCC' } },
      }
    };
    const cellStyle = {
      alignment: { vertical: 'top', wrapText: true },
      border: {
        top: { style: 'thin', color: { rgb: 'E0E0E0' } },
        bottom: { style: 'thin', color: { rgb: 'E0E0E0' } },
        left: { style: 'thin', color: { rgb: 'E0E0E0' } },
        right: { style: 'thin', color: { rgb: 'E0E0E0' } },
      }
    };

    const makeSheet = (headers, rows, colWidths) => {
      const data = [
        headers.map(h => ({ v: h, t: 's', s: headerStyle })),
        ...rows.map(row => row.map(val => ({ v: val || '', t: 's', s: cellStyle })))
      ];
      const ws = XLSXStyle.utils.aoa_to_sheet(data);
      ws['!cols'] = colWidths.map(w => ({ wch: w }));
      ws['!rows'] = [{ hpt: 22 }];
      return ws;
    };

    // Sheet "store"
    const storeRows = results.map(res => [
      res.imageUrl || '',
      res.projectName || '',
      res.affiliateLink || '',
      res.descContent || '',
      res.discountPercent ? getSaleText(res.discountPercent) : '',
      res.discountPercent ? getSaleText(res.discountPercent) : '',
      t.trending,
    ]);
    const wsStore = makeSheet(
      ['image url', 'title', 'link', 'description', 'sale', 'rating', 'Status(Trending, Active,Gold,Sale)'],
      storeRows,
      [30, 22, 32, 70, 35, 35, 28]
    );

    // Sheet "coupon"
    const couponRows = getCouponTableRows().map(row => [
      String(row.stt),
      '',
      row.code || '',
      row.saleOff || '',
      row.titleDesc || '',
      row.titleDesc || '',
      row.storeName || '',
      row.category || '',
      row.link || '',
    ]);
    const wsCoupon = makeSheet(
      ['STT', 'image url', 'code', 'sale off (Nếu có)', 'title', 'description', 'tên store', 'Category', 'Link'],
      couponRows,
      [6, 20, 16, 18, 50, 50, 22, 22, 32]
    );

    const wb = XLSXStyle.utils.book_new();
    XLSXStyle.utils.book_append_sheet(wb, wsStore, 'store');
    XLSXStyle.utils.book_append_sheet(wb, wsCoupon, 'coupon');

    const firstName = results[0]?.descTitle?.replace(/[^a-zA-Z0-9]/g, '_') || 'export';
    XLSXStyle.writeFile(wb, `coupon_import_${firstName}.xlsx`);
  };

  return (
    <div className={`min-h-screen flex flex-col relative overflow-x-hidden font-sans selection:bg-red-500/30 ${isDark ? 'dark bg-[#050505] text-white' : 'bg-gray-50 text-gray-900'}`}>
      
      {/* Navbar */}
      <nav className="w-full border-b border-gray-200 dark:border-gray-800 bg-white/95 dark:bg-[#0a0a0a]/95 backdrop-blur-md fixed top-0 z-50 transition-all duration-300 shadow-sm dark:shadow-none">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex-shrink-0 flex items-center gap-3">
              <div className="bg-gradient-to-br from-red-600 to-red-500 p-2 rounded-lg shadow-[0_0_15px_rgba(239,68,68,0.4)]">
                <img src="https://couponhub.me/wp-content/uploads/2026/04/cropped-trong-suot.png" alt="CouponHub Logo" className="w-5 h-5 object-contain" />
              </div>
              <div>
                <span className="text-gray-900 dark:text-white font-bold text-lg tracking-tight block">SEO PROMO PRO</span>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="text-gray-400 text-xs">
                Powered by{' '}
                <a
                  href="https://hosyquan.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-red-500 hover:text-red-600 font-semibold transition-colors"
                >
                  Hồ Quân
                </a>
              </div>
              <button
                onClick={() => {
                  const next = !isDark;
                  setIsDark(next);
                  localStorage.setItem('theme', next ? 'dark' : 'light');
                }}
                title={isDark ? 'Chuyển sang Light Mode' : 'Chuyển sang Dark Mode'}
                className={`p-2 rounded-xl border transition-all ${isDark ? 'bg-gray-800 border-gray-700 text-yellow-400 hover:bg-gray-700' : 'bg-gray-100 border-gray-200 text-gray-500 hover:bg-gray-200'}`}
              >
                {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Layout */}
      <main className="w-full max-w-5xl mx-auto flex flex-col gap-8 px-4 pb-20 mt-24">
        
        {/* Phần 1 - Input */}
        <div className="bg-white dark:bg-[#121212] border border-gray-200 dark:border-gray-800 p-8 rounded-3xl shadow-sm dark:shadow-none relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-64 h-64 bg-red-50 dark:bg-red-900/5 rounded-full blur-[80px] -z-10 transition duration-700"></div>

          <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-6 flex items-center">
            <span className="bg-gray-100 dark:bg-gray-800 p-2 rounded-lg mr-3 border border-gray-200 dark:border-gray-700">
              <Sliders className="w-5 h-5 text-red-500" />
            </span>
            Cấu Hình & Đầu Vào
          </h2>

          <form onSubmit={handleGenerate}>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-2">
              <div>
                <label className="block text-gray-500 text-[10px] font-bold uppercase tracking-wider mb-2 ml-1">Nhà Cung Cấp</label>
                <select value={provider} onChange={handleProviderChange} className="w-full py-3 px-4 bg-gray-50 dark:bg-[#1a1a1a] border border-gray-300 dark:border-[#333] rounded-xl text-sm text-gray-900 dark:text-white appearance-none focus:border-red-500 focus:ring-1 focus:ring-red-500 outline-none">
                  <option value="google">Google (Gemini)</option>
                  <option value="openai">OpenAI (GPT)</option>
                  <option value="deepseek">DeepSeek</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-500 text-[10px] font-bold uppercase tracking-wider mb-2 ml-1">Model</label>
                <select value={selectedModel} onChange={(e) => { setSelectedModel(e.target.value); localStorage.setItem('selected_model', e.target.value); }} className="w-full py-3 px-4 bg-gray-50 dark:bg-[#1a1a1a] border border-gray-300 dark:border-[#333] rounded-xl text-sm text-gray-900 dark:text-white appearance-none focus:border-red-500 focus:ring-1 focus:ring-red-500 outline-none">
                  {modelOptions[provider].map(opt => <option key={opt.value} value={opt.value}>{opt.text}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-gray-400 text-[10px] font-bold uppercase tracking-wider mb-2 ml-1 flex items-center gap-1.5">
                  <span>🌐</span> Ngôn Ngữ Đầu Ra
                </label>
                <select
                  value={outputLanguage}
                  onChange={(e) => { setOutputLanguage(e.target.value); localStorage.setItem('output_language', e.target.value); }}
                  className="w-full py-3 px-4 bg-gray-50 dark:bg-[#1a1a1a] border border-blue-300 dark:border-blue-900/60 rounded-xl text-sm text-gray-900 dark:text-white appearance-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none"
                >
                  {languageOptions.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.flag} {opt.text}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-gray-500 text-[10px] font-bold uppercase tracking-wider mb-2 ml-1">Mật Khẩu Tool</label>
                <input
                  type="password"
                  value={toolPassword}
                  onChange={(e) => { 
                    const val = e.target.value;
                    setToolPassword(val);
                    setIsAuthenticated(val === '123');

                    localStorage.setItem('tool_password', val);
                  }}
                  placeholder="Nhập mật khẩu..."
                  className={`w-full py-3 px-4 rounded-xl text-sm outline-none border ${isDark ? 'bg-[#1a1a1a] text-white' : 'bg-gray-50 text-gray-900'} ${isAuthenticated ? 'border-green-600 focus:ring-1 focus:ring-green-600' : toolPassword ? 'border-red-700 focus:ring-1 focus:ring-red-700' : isDark ? 'border-[#333] focus:border-red-500 focus:ring-1 focus:ring-red-500' : 'border-gray-300 focus:border-red-500 focus:ring-1 focus:ring-red-500'}`}
                />
                {toolPassword && !isAuthenticated && (
                  <p className="text-red-500 text-[10px] mt-1 ml-1 flex items-center gap-1">
                    <AlertCircle className="w-3 h-3" /> Sai mật khẩu
                  </p>
                )}
                {isAuthenticated && (
                  <p className="text-green-600 text-[10px] mt-1 ml-1 flex items-center gap-1">
                    <Check className="w-3 h-3" /> Đã xác thực
                  </p>
                )}
              </div>
            </div>

            <div className="mb-6 relative mt-4">
              <label className="block text-gray-500 text-[10px] font-bold uppercase tracking-wider mb-2 ml-1">
                {providerInfo[provider].label}
              </label>
              <div className="flex gap-2">
                <input
                  type="password"
                  value={apiKeys[provider]}
                  onChange={handleApiKeyChange}
                  placeholder={`Nhập ${providerInfo[provider].label} của bạn...`}
                  className="w-full py-3 px-4 bg-gray-50 dark:bg-[#1a1a1a] border border-gray-300 dark:border-[#333] rounded-xl text-sm text-gray-900 dark:text-white focus:border-red-500 focus:ring-1 focus:ring-red-500 outline-none"
                />
              </div>
            </div>

            {/* Loại Sản Phẩm */}
            <div className="mb-6">
              <label className="block text-gray-500 text-[10px] font-bold uppercase tracking-wider mb-2 ml-1">
                Loại Sản Phẩm / Store
              </label>
              <div className="flex gap-2">
                {productTypeOptions.map(opt => (
                  <button
                    key={opt.value}
                    type="button"
                    onClick={() => { setProductType(opt.value); localStorage.setItem('product_type', opt.value); }}
                    className={`flex-1 py-2.5 px-3 rounded-xl text-sm font-semibold border transition-all flex items-center justify-center gap-2 ${
                      productType === opt.value
                        ? 'bg-purple-50 dark:bg-purple-600/20 border-purple-400 dark:border-purple-500 text-purple-700 dark:text-purple-300 shadow-sm'
                        : 'bg-gray-50 dark:bg-[#1a1a1a] border-gray-300 dark:border-[#333] text-gray-500 dark:text-gray-400 hover:border-gray-400 dark:hover:border-gray-500 hover:text-gray-700 dark:hover:text-gray-300'
                    }`}
                  >
                    <span>{opt.icon}</span>
                    <span>{opt.label}</span>
                  </button>
                ))}
              </div>
              <p className="text-[10px] text-gray-400 mt-1.5 ml-1 italic">
                {productType === 'digital'  && '💻 AI sẽ tập trung vào tính năng số, không đề cập vận chuyển. Hàng "Free" → Free Access.'}
                {productType === 'physical' && '📦 AI sẽ đề cập chất lượng sản phẩm, vận chuyển. Hàng "Free" → Free Shipping.'}
                {productType === 'service'  && '🔧 AI sẽ tập trung vào giá trị dịch vụ, hỗ trợ, gói cước. Hàng "Free" → Free Trial.'}
              </p>
            </div>

            {/* Khối Nhập Nhanh */}
            <div className="mb-6 border-t border-gray-200 dark:border-gray-800 pt-6">
              <div className="flex justify-between items-center mb-2">
                <label className="block text-green-600 text-[10px] font-bold uppercase tracking-wider ml-1 flex items-center gap-1.5">
                  <Zap className="w-3.5 h-3.5" /> Nhập Nhanh Hàng Loạt (Paste nhiều dòng từ Excel)
                </label>
                {projectsQueue.length > 1 && (
                  <button 
                    type="button" 
                    onClick={() => {
                      setProjectsQueue([initialSingleProject]);
                      setQuickPasteValue('');
                    }}
                    className="text-xs text-red-500 hover:text-red-600 underline flex items-center gap-1"
                  >
                    <Trash2 className="w-3 h-3" /> Xóa tất cả
                  </button>
                )}
              </div>
              <textarea
                value={quickPasteValue}
                onChange={handleQuickPaste}
                placeholder="Dán 1 hoặc NHIỀU dòng từ Excel vào đây để THÊM vào danh sách hiện tại..."
                className="w-full py-3 px-4 bg-gray-50 dark:bg-[#1a1a1a] border border-green-300 dark:border-green-900/50 rounded-xl text-sm text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-600 focus:border-green-500 focus:ring-1 focus:ring-green-500 outline-none resize-none h-20"
              />
              <p className="text-[10px] text-gray-400 mt-2 ml-1 italic">
                Thứ tự cột Excel: Danh mục | Tên store | Link web | Sàn | Logo | Link login | user | Pass | Tình trạng | Link affiliate | Payment | Mã coupon | Offer
              </p>
              <p className="text-[10px] text-green-600 mt-1 ml-1 font-medium">
                💡 Mỗi lần paste sẽ THÊM vào danh sách hiện tại (không xóa dự án cũ)
              </p>
            </div>

            {/* Khối Danh sách Queue hoặc Single Input */}
            {projectsQueue.length > 1 ? (
              <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 border border-gray-200 dark:border-gray-700 rounded-xl p-4">
                <div className="flex justify-between items-center mb-3">
                  <span className="text-sm font-bold text-green-600 flex items-center gap-2">
                    <ListOrdered className="w-4 h-4" /> Danh sách {projectsQueue.length} dự án
                  </span>
                  <button type="button" onClick={clearQueue} className="text-xs text-red-500 hover:text-red-600 underline flex items-center gap-1">
                    <Trash2 className="w-3 h-3" /> Reset về 1 dự án
                  </button>
                </div>
                
                <div className="max-h-64 overflow-y-auto overflow-x-auto border border-gray-200 dark:border-gray-700 rounded-lg custom-scrollbar">
                  <table className="w-full text-left text-xs text-gray-700 dark:text-gray-300 whitespace-nowrap">
                    <thead className="uppercase bg-gray-100 dark:bg-gray-900/80 text-gray-500 sticky top-0 z-10 text-[10px]">
                      <tr>
                        <th className="px-3 py-2.5 border-b border-gray-200 font-bold">STT</th>
                        <th className="px-3 py-2.5 border-b border-gray-200 font-bold">Danh mục</th>
                        <th className="px-3 py-2.5 border-b border-gray-200 font-bold">Tên Store</th>
                        <th className="px-3 py-2.5 border-b border-gray-200 font-bold">Website</th>
                        <th className="px-3 py-2.5 border-b border-gray-200 font-bold">Logo</th>
                        <th className="px-3 py-2.5 border-b border-gray-200 font-bold">Link Affiliate</th>
                        <th className="px-3 py-2.5 border-b border-gray-200 font-bold">Mã Coupon</th>
                        <th className="px-3 py-2.5 border-b border-gray-200 font-bold">Offer</th>
                        <th className="px-3 py-2.5 border-b border-gray-200 font-bold"></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100 dark:divide-gray-800/50">
                      {projectsQueue.map((p, i) => (
                        <tr key={i} className="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors group">
                          <td className="px-3 py-2 text-center font-semibold text-gray-400">{i + 1}</td>
                          <td className="px-3 py-2">{p.category || <span className="text-gray-600">-</span>}</td>
                          <td className="px-3 py-2 font-medium text-gray-900 dark:text-gray-100">{p.projectName || <span className="text-gray-600">-</span>}</td>
                          <td className="px-3 py-2 text-blue-600 max-w-[120px] truncate" title={p.websiteUrl}>{p.websiteUrl || <span className="text-gray-600">-</span>}</td>
                          <td className="px-3 py-2 text-gray-500 max-w-[100px] truncate" title={p.imageUrl}>{p.imageUrl || <span className="text-gray-600">-</span>}</td>
                          <td className="px-3 py-2 text-blue-600 max-w-[120px] truncate" title={p.affiliateLink}>{p.affiliateLink || <span className="text-gray-600">-</span>}</td>
                          <td className="px-3 py-2 font-medium text-green-600">{p.couponCode || <span className="text-gray-600">-</span>}</td>
                          <td className="px-3 py-2 font-medium text-red-500">{p.discountPercent || <span className="text-gray-600">-</span>}</td>
                          <td className="px-3 py-2 text-center">
                            <button
                              type="button"
                              onClick={() => setProjectsQueue(prev => prev.filter((_, idx) => idx !== i))}
                              title="Xóa dòng này"
                              className="text-red-400 hover:text-red-600 p-1 rounded"
                            >
                              <Trash2 className="w-3.5 h-3.5" />
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <p className="text-[10px] text-gray-400 mt-3 text-center">Các ô nhập lẻ đã được ẩn đi. Paste thêm dữ liệu vào ô trên để bổ sung danh sách. Bấm "Bắt Đầu" để xử lý toàn bộ.</p>
              </div>
            ) : (
              // Form Single Input cổ điển
              <>
                <div className="mb-6 border-t border-gray-200 dark:border-gray-800 pt-6">
                  <label className="block text-gray-500 text-[10px] font-bold uppercase tracking-wider mb-2 ml-1">Tên dự án / Thương hiệu <span className="text-red-500">*</span></label>
                  <input type="text" value={projectsQueue[0].projectName} onChange={(e) => updateSingleQueueField('projectName', e.target.value)} placeholder="VD: 11six24" required className="w-full py-3 px-4 bg-gray-50 dark:bg-[#1a1a1a] border border-gray-300 dark:border-[#333] rounded-xl text-sm text-gray-900 dark:text-white focus:border-red-500 focus:ring-1 focus:ring-red-500 outline-none" />
                </div>
                <div className="mb-6">
                  <label className="block text-gray-500 text-[10px] font-bold uppercase tracking-wider mb-2 ml-1">Website dự án</label>
                  <input type="url" value={projectsQueue[0].websiteUrl} onChange={(e) => updateSingleQueueField('websiteUrl', e.target.value)} placeholder="VD: https://11six24.com/" className="w-full py-3 px-4 bg-gray-50 dark:bg-[#1a1a1a] border border-gray-300 dark:border-[#333] rounded-xl text-sm text-gray-900 dark:text-white focus:border-red-500 focus:ring-1 focus:ring-red-500 outline-none" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-gray-500 text-[10px] font-bold uppercase tracking-wider mb-2 ml-1">Link Ảnh (image url)</label>
                    <input type="text" value={projectsQueue[0].imageUrl} onChange={(e) => updateSingleQueueField('imageUrl', e.target.value)} placeholder="VD: https://domain.com/logo.svg" className="w-full py-3 px-4 bg-gray-50 dark:bg-[#1a1a1a] border border-gray-300 dark:border-[#333] rounded-xl text-sm text-gray-900 dark:text-white focus:border-red-500 focus:ring-1 focus:ring-red-500 outline-none" />
                  </div>
                  <div>
                    <label className="block text-gray-500 text-[10px] font-bold uppercase tracking-wider mb-2 ml-1">Link Affiliate</label>
                    <input type="text" value={projectsQueue[0].affiliateLink} onChange={(e) => updateSingleQueueField('affiliateLink', e.target.value)} placeholder="VD: https://affiliate.com/?ref=..." className="w-full py-3 px-4 bg-gray-50 dark:bg-[#1a1a1a] border border-gray-300 dark:border-[#333] rounded-xl text-sm text-gray-900 dark:text-white focus:border-red-500 focus:ring-1 focus:ring-red-500 outline-none" />
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label className="block text-gray-500 text-[10px] font-bold uppercase tracking-wider mb-2 ml-1">Mức Giảm Giá (%, $, v.v.)</label>
                    <input type="text" value={projectsQueue[0].discountPercent} onChange={(e) => updateSingleQueueField('discountPercent', e.target.value)} placeholder="VD: 15%, 15$, $20 Off..." className="w-full py-3 px-4 bg-gray-50 dark:bg-[#1a1a1a] border border-gray-300 dark:border-[#333] rounded-xl text-sm text-gray-900 dark:text-white focus:border-red-500 focus:ring-1 focus:ring-red-500 outline-none" />
                  </div>
                  <div>
                    <label className="block text-gray-500 text-[10px] font-bold uppercase tracking-wider mb-2 ml-1">Mã Coupon (Code)</label>
                    <input type="text" value={projectsQueue[0].couponCode} onChange={(e) => updateSingleQueueField('couponCode', e.target.value)} placeholder="VD: WELCOME10" className="w-full py-3 px-4 bg-gray-50 dark:bg-[#1a1a1a] border border-gray-300 dark:border-[#333] rounded-xl text-sm text-gray-900 dark:text-white focus:border-red-500 focus:ring-1 focus:ring-red-500 outline-none" />
                  </div>
                </div>
                <div className="mb-8">
                  <label className="block text-gray-500 text-[10px] font-bold uppercase tracking-wider mb-2 ml-1">Danh mục (Category)</label>
                  <input type="text" value={projectsQueue[0].category} onChange={(e) => updateSingleQueueField('category', e.target.value)} placeholder="VD: Software, Fashion..." className="w-full py-3 px-4 bg-gray-50 dark:bg-[#1a1a1a] border border-gray-300 dark:border-[#333] rounded-xl text-sm text-gray-900 dark:text-white focus:border-red-500 focus:ring-1 focus:ring-red-500 outline-none" />
                </div>
              </>
            )}

            {error && (
              <div className="mb-6 flex items-start gap-2 text-red-600 bg-red-50 p-4 rounded-xl text-sm border border-red-200">
                <AlertCircle className="w-5 h-5 flex-shrink-0" /><span>{error}</span>
              </div>
            )}

            <div className="flex gap-3">
              <button
                type="submit"
                disabled={isLoading || (!projectsQueue[0].projectName.trim() && projectsQueue.length === 1) || !isAuthenticated}
                className="flex-1 bg-gradient-to-r from-red-600 to-red-500 hover:to-red-400 disabled:from-gray-300 disabled:to-gray-200 disabled:text-gray-400 text-white font-bold py-4 px-6 rounded-2xl flex justify-center items-center gap-3 text-lg transition-all shadow-[0_0_15px_rgba(239,68,68,0.4)]"
              >
                {isLoading ? (
                  <><Loader2 className="w-6 h-6 animate-spin" /><span>{loadingStatus}</span></>
                ) : (
                  <><Rocket className="w-5 h-5" /><span>Bắt Đầu Tạo Nội Dung</span></>
                )}
              </button>
              <button
                type="button"
                disabled={isLoading}
                onClick={() => {
                  setProjectsQueue([initialSingleProject]);
                  setQuickPasteValue('');
                  setResults([]);
                  setAddedCoupons([]);
                  setError('');
                  localStorage.removeItem('projects_queue');
                  localStorage.removeItem('quick_paste');
                  localStorage.removeItem('added_coupons');
                }}
                className="bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 disabled:opacity-50 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white font-bold py-4 px-5 rounded-2xl flex items-center gap-2 text-sm transition-all border border-gray-300 dark:border-gray-700"
                title="Reset toàn bộ dữ liệu"
              >
                <Trash2 className="w-5 h-5" /><span>Reset</span>
              </button>
            </div>
            <div className="mt-3 flex flex-col gap-2">
              <button
                type="button"
                onClick={downloadFaqXlsx}
                disabled={results.length === 0}
                className="w-full py-3 px-5 rounded-2xl flex items-center justify-center gap-2 text-sm font-bold border transition-all bg-blue-50 dark:bg-blue-900/20 hover:bg-blue-100 dark:hover:bg-blue-900/30 text-blue-600 dark:text-blue-400 border-blue-200 dark:border-blue-800 disabled:opacity-40 disabled:cursor-not-allowed"
              >
                <Download className="w-4 h-4" /> Tải Về FAQ Import (.xlsx)
              </button>
              <button
                type="button"
                onClick={downloadCouponXlsx}
                disabled={results.length === 0}
                className="w-full py-3 px-5 rounded-2xl flex items-center justify-center gap-2 text-sm font-bold border transition-all bg-green-50 dark:bg-green-900/20 hover:bg-green-100 dark:hover:bg-green-900/30 text-green-600 dark:text-green-400 border-green-200 dark:border-green-800 disabled:opacity-40 disabled:cursor-not-allowed"
              >
                <Download className="w-4 h-4" /> Tải Về Coupon Code (.xlsx)
              </button>
            </div>
          </form>
        </div>

        {/* Phần 2 - Output: Mô Tả SEO */}
        <div className="bg-white dark:bg-[#121212] border border-gray-200 dark:border-gray-800 p-8 rounded-3xl shadow-sm dark:shadow-none relative overflow-hidden flex flex-col">
          <div className="flex justify-between items-center mb-6 border-b border-gray-200 dark:border-gray-800 pb-4">
            <h2 className="text-lg font-bold text-gray-900 dark:text-white flex items-center">
              <AlignLeft className="w-5 h-5 mr-3 text-red-500" /> Mô Tả Sản Phẩm (Hàng Loạt)
            </h2>
            <button onClick={copyDescToExcel} disabled={results.length === 0} className={`text-[10px] font-bold uppercase tracking-wider py-2 px-4 rounded-full transition border flex items-center gap-2 ${isCopiedDesc ? 'bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400 border-green-200 dark:border-green-900/50' : 'bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 border-gray-300 dark:border-gray-700 disabled:opacity-50'}`}>
              {isCopiedDesc ? <><Check className="w-3.5 h-3.5" /> Đã Copy Bảng</> : <><Copy className="w-3.5 h-3.5" /> Copy Dán Excel</>}
            </button>
          </div>
          <div className={`overflow-x-auto border border-gray-200 dark:border-gray-800 rounded-xl bg-white dark:bg-[#0a0a0a] ${isLoading && results.length===0 ? 'opacity-50 pointer-events-none' : ''}`}>
            <table className="w-full text-left text-sm text-gray-700 dark:text-gray-300">
              <thead className="text-xs uppercase bg-gray-50 dark:bg-gray-900/50 text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-800">
                <tr><th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800 w-[30%]">Tên Sản Phẩm</th><th className="px-4 py-4 w-[70%]">Mô Tả Sản Phẩm</th></tr>
              </thead>
              <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                {results.length > 0 ? results.map((res, idx) => (
                  <tr key={idx} className="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors">
                    <td className="px-4 py-4 border-r border-gray-200 dark:border-gray-800 font-medium text-gray-600 dark:text-gray-300 align-top">{res.descTitle}</td>
                    <td className="px-4 py-4 leading-relaxed align-top whitespace-pre-wrap">{res.descContent}</td>
                  </tr>
                )) : (
                  <tr><td colSpan="2" className="px-4 py-8 text-center text-gray-400 italic">Dữ liệu sẽ hiện ở đây sau khi tạo...</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Phần 3 - Output: Bảng FAQ */}
        <div className="bg-white dark:bg-[#121212] border border-gray-200 dark:border-gray-800 p-8 rounded-3xl shadow-sm dark:shadow-none relative overflow-hidden flex flex-col">
          <div className="flex justify-between items-center mb-6 border-b border-gray-200 dark:border-gray-800 pb-4">
            <h2 className="text-lg font-bold text-gray-900 dark:text-white flex items-center">
              <Table className="w-5 h-5 mr-3 text-red-500" /> Bảng FAQ (Hàng Loạt)
            </h2>
            <div className="flex gap-2">
              <button onClick={copyTableToExcel} disabled={results.length === 0} className={`text-[10px] font-bold uppercase tracking-wider py-2 px-4 rounded-full transition border flex items-center gap-2 ${isCopiedTable ? 'bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400 border-green-200 dark:border-green-900/50' : 'bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 border-gray-300 dark:border-gray-700 disabled:opacity-50'}`}>
                {isCopiedTable ? <><Check className="w-3.5 h-3.5" /> Đã Copy Bảng</> : <><Copy className="w-3.5 h-3.5" /> Copy Dán Excel</>}
              </button>
              <button onClick={downloadFaqXlsx} disabled={results.length === 0} className="text-[10px] font-bold uppercase tracking-wider py-2 px-4 rounded-full transition border flex items-center gap-2 bg-blue-50 dark:bg-blue-900/20 hover:bg-blue-100 dark:hover:bg-blue-900/30 text-blue-600 dark:text-blue-400 border-blue-200 dark:border-blue-900/50 disabled:opacity-50">
                <Download className="w-3.5 h-3.5" /> Tải Về FAQ Import
              </button>
            </div>
          </div>
          <div className="overflow-x-auto border border-gray-200 dark:border-gray-800 rounded-xl bg-white dark:bg-[#0a0a0a] max-h-[600px] overflow-y-auto">
            <table className="w-full text-left text-sm text-gray-700 dark:text-gray-300">
              <thead className="text-xs uppercase bg-gray-50 dark:bg-gray-900/50 text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-800 sticky top-0 z-10">
                <tr>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800 w-[40%]">Question</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800 w-[45%]">Answer</th>
                  <th className="px-4 py-4 w-[15%]">Store Name</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                {results.length > 0 ? results.flatMap(res => res.faq || []).map((row, i) => (
                  <tr key={i} className="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors">
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800">{row.question}</td>
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800">{row.answer}</td>
                    <td className="px-4 py-3 font-medium text-gray-500 dark:text-gray-400">{row.store}</td>
                  </tr>
                )) : <tr><td colSpan="3" className="px-4 py-8 text-center text-gray-400 italic">Dữ liệu sẽ hiện ở đây sau khi tạo...</td></tr>}
              </tbody>
            </table>
          </div>
        </div>

        {/* Phần 4 - Output: Bảng STORE */}
        <div className="bg-white dark:bg-[#121212] border border-gray-200 dark:border-gray-800 p-8 rounded-3xl shadow-sm dark:shadow-none relative overflow-hidden flex flex-col">
          <div className="flex justify-between items-center mb-6 border-b border-gray-200 dark:border-gray-800 pb-4">
            <h2 className="text-lg font-bold text-gray-900 dark:text-white flex items-center">
              <ShoppingBag className="w-5 h-5 mr-3 text-red-500" /> Bảng STORE (Hàng Loạt)
            </h2>
            <button onClick={copyStoreToExcel} disabled={results.length === 0} className={`text-[10px] font-bold uppercase tracking-wider py-2 px-4 rounded-full transition border flex items-center gap-2 ${isCopiedStore ? 'bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400 border-green-200 dark:border-green-900/50' : 'bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 border-gray-300 dark:border-gray-700 disabled:opacity-50'}`}>
              {isCopiedStore ? <><Check className="w-3.5 h-3.5" /> Đã Copy Bảng</> : <><Copy className="w-3.5 h-3.5" /> Copy Dán Excel</>}
            </button>
          </div>
          <div className="overflow-x-auto border border-gray-200 dark:border-gray-800 rounded-xl bg-white dark:bg-[#0a0a0a]">
            <table className="w-full text-left text-sm text-gray-700 dark:text-gray-300">
              <thead className="text-xs uppercase bg-gray-50 dark:bg-gray-900/50 text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-800 whitespace-nowrap">
                <tr>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800">image url</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800">title</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800">link</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800 min-w-[300px]">description</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800">sale</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800">rating</th>
                  <th className="px-4 py-4">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                {results.length > 0 ? results.map((res, i) => (
                  <tr key={i} className="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors">
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800 max-w-[150px] truncate" title={res.imageUrl}>{res.imageUrl || <span className="text-gray-400 italic">Trống</span>}</td>
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800 font-medium text-gray-700 dark:text-gray-400">{res.projectName}</td>
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800 max-w-[150px] truncate" title={res.affiliateLink}>{res.affiliateLink || <span className="text-gray-400 italic">Trống</span>}</td>
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800">
                      {/* Thêm whitespace-pre-wrap để hiển thị đúng việc xuống dòng trên giao diện web */}
                      <div className="line-clamp-3 whitespace-pre-wrap" title={res.descContent}>{res.descContent}</div>
                    </td>
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800">{res.discountPercent ? getSaleText(res.discountPercent) : <span className="text-gray-400 italic">Trống</span>}</td>
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800">{res.discountPercent ? getSaleText(res.discountPercent) : <span className="text-gray-400 italic">Trống</span>}</td>
                    <td className="px-4 py-3 font-medium text-green-600">{t.trending}</td>
                  </tr>
                )) : <tr><td colSpan="7" className="px-4 py-8 text-center text-gray-400 italic">Dữ liệu sẽ hiện ở đây sau khi tạo...</td></tr>}
              </tbody>
            </table>
          </div>
        </div>

        {/* Phần 5 - Output: Bảng COUPON động */}
        <div className="bg-white dark:bg-[#121212] border border-gray-200 dark:border-gray-800 p-8 rounded-3xl shadow-sm dark:shadow-none relative overflow-hidden flex flex-col">
          <div className="flex justify-between items-center mb-6 border-b border-gray-200 dark:border-gray-800 pb-4">
            <h2 className="text-lg font-bold text-gray-900 dark:text-white flex items-center">
              <Tag className="w-5 h-5 mr-3 text-red-500" /> Bảng COUPON (Hàng Loạt - Sửa trực tiếp)
            </h2>
            <div className="flex gap-3">
              <button onClick={copyCouponToExcel} className={`text-[10px] font-bold uppercase tracking-wider py-2 px-4 rounded-full transition border flex items-center gap-2 ${isCopiedCoupon ? 'bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400 border-green-200 dark:border-green-900/50' : 'bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300 border-gray-300 dark:border-gray-700 disabled:opacity-50'}`}>
                {isCopiedCoupon ? <><Check className="w-3.5 h-3.5" /> Đã Copy Bảng</> : <><Copy className="w-3.5 h-3.5" /> Copy Dán Excel</>}
              </button>
            </div>
          </div>

          <div className="overflow-x-auto border border-gray-200 dark:border-gray-800 rounded-xl bg-white dark:bg-[#0a0a0a] max-h-[800px]">
            <table className="w-full text-left text-sm text-gray-700 dark:text-gray-300">
              <thead className="text-xs uppercase bg-gray-50 dark:bg-gray-900/50 text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-800 whitespace-nowrap sticky top-0 z-10">
                <tr>
                  <th className="px-2 py-4 border-r border-gray-200 dark:border-gray-800 text-center w-12">Thêm/Xóa</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800">STT</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800">image url</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800 min-w-[150px]">code</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800 min-w-[150px]">sale off (Nếu có)</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800">title</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800">description</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800">tên store</th>
                  <th className="px-4 py-4 border-r border-gray-200 dark:border-gray-800">Category</th>
                  <th className="px-4 py-4">Link</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                {allCouponRows.length > 0 ? allCouponRows.map((row) => (
                  <tr key={row.id} className="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors group">
                    <td className="px-2 py-3 text-center border-r border-gray-200 dark:border-gray-800">
                      {row.rowType === 'global-code' ? (
                        <button onClick={() => handleAddCouponRow(row.projectId)} title={`Thêm mã mới cho ${row.storeName}`} className="text-green-600 hover:text-green-700 bg-green-50 dark:bg-green-900/30 p-1.5 rounded-md border border-green-200 dark:border-green-800 mx-auto block">
                          <Plus className="w-4 h-4" />
                        </button>
                      ) : row.rowType === 'custom' ? (
                        <button onClick={() => handleRemoveCouponRow(row.id)} title="Xóa hàng này" className="text-red-500 hover:text-red-600 bg-red-50 dark:bg-red-900/30 p-1.5 rounded-md border border-red-200 dark:border-red-800 mx-auto block">
                          <Trash2 className="w-4 h-4" />
                        </button>
                      ) : null}
                    </td>
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800 text-center font-bold">{row.stt}</td>
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800 text-gray-400 italic">Trống</td>
                    
                    {/* CỘT CODE */}
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800 font-medium text-green-600">
                      {row.rowType === 'global-code' ? (
                        <input value={row.code} onChange={(e) => updateResultData(row.projectId, 'couponCode', e.target.value)} className="bg-transparent border-b border-transparent focus:border-green-500 w-full outline-none text-gray-900 dark:text-white" placeholder="Nhập Code..." />
                      ) : row.rowType === 'custom' ? (
                        <input value={row.code} onChange={(e) => updateAddedCoupon(row.id, 'code', e.target.value)} className="bg-transparent border-b border-transparent focus:border-green-500 w-full outline-none text-gray-900 dark:text-white" placeholder="Nhập Code..." />
                      ) : <span className="text-gray-400 italic font-normal">Trống</span>}
                    </td>

                    {/* CỘT SALE OFF */}
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800 font-medium text-gray-900 dark:text-white">
                      {row.rowType === 'global-code' || row.rowType === 'global-nocode' ? (
                        <input value={row.saleOff} onChange={(e) => updateResultData(row.projectId, 'discountPercent', e.target.value)} className="bg-transparent border-b border-transparent focus:border-red-500 w-full outline-none text-gray-900 dark:text-white" placeholder="Nhập Sale..." />
                      ) : row.rowType === 'custom' ? (
                        <input value={row.saleOff} onChange={(e) => updateAddedCoupon(row.id, 'saleOff', e.target.value)} className="bg-transparent border-b border-transparent focus:border-red-500 w-full outline-none text-gray-900 dark:text-white" placeholder="Nhập Sale..." />
                      ) : row.saleOff}
                    </td>

                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800 text-gray-700 dark:text-gray-300">{row.titleDesc}</td>
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800 text-gray-700 dark:text-gray-300">{row.titleDesc}</td>
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800">{row.storeName}</td>
                    <td className="px-4 py-3 border-r border-gray-200 dark:border-gray-800">{row.category || <span className="text-gray-400 italic">Trống</span>}</td>
                    <td className="px-4 py-3 max-w-[150px] truncate" title={row.link}>{row.link || <span className="text-gray-400 italic">Trống</span>}</td>
                  </tr>
                )) : <tr><td colSpan="10" className="px-4 py-8 text-center text-gray-400 italic">Dữ liệu sẽ hiện ở đây sau khi tạo...</td></tr>}
              </tbody>
            </table>
          </div>
        </div>

      </main>

      {/* Floating loading toast */}
      {isLoading && (
        <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 px-5 py-3 rounded-2xl shadow-xl border text-sm font-medium bg-white dark:bg-[#1a1a1a] border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-200 max-w-[90vw]">
          <Loader2 className="w-4 h-4 animate-spin text-red-500 flex-shrink-0" />
          <span className="truncate">{loadingStatus || 'Đang xử lý...'}</span>
        </div>
      )}
    </div>
  );
}